import React, { useState, useEffect } from 'react';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import cx from 'classnames';
import styles from './EditFormNameModal.module.scss';

interface EditFormNameModalProps {
    formId: string;
    currentName: string;
    onConfirm: (formId: string, newName: string) => void;
    onCancel: () => void;
}

const Index: React.FC<EditFormNameModalProps> = ({
    formId,
    currentName,
    onConfirm,
    onCancel
}) => {
    const [formName, setFormName] = useState(currentName);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setFormName(currentName);
    }, [currentName]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!formName.trim()) {
            return;
        }

        if (formName.trim() === currentName) {
            onCancel();
            return;
        }

        setIsSubmitting(true);
        try {
            onConfirm(formId, formName.trim());
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <div>
                <Heading level={3} classes="modal-heading">
                    Formular umbenennen
                </Heading>
            </div>

            <form onSubmit={handleSubmit}>
                <div className={cx(styles['form-group'])}>
                    <label 
                        htmlFor="form-name" 
                        className={cx(styles['form-label'])}
                    >
                        Neuer Formularname:
                    </label>
                    <input
                        id="form-name"
                        type="text"
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        placeholder="z.B. Kontaktformular Hauptseite"
                        required
                        autoFocus
                        className={cx(styles['form-input'])}
                    />
                </div>

                <div className={cx(styles['button-container'])}>
                    <Button
                        type="button"
                        hierarchy="secondary"
                        fn={onCancel}
                        disabled={isSubmitting}
                        text="Abbrechen"
                    />
                    <Button
                        type="submit"
                        hierarchy="primary"
                        disabled={!formName.trim() || isSubmitting || formName.trim() === currentName}
                        text={isSubmitting ? 'Speichere...' : 'Speichern'}
                    />
                </div>
            </form>
        </div>
    );
};

export default Index; 